import React, { FC, useMemo } from "react";
import { Box, Paper, Typography } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { FlexBetween, FlexBox } from "components/flex-box";
import LazyImage from "components/LazyImage";
import { H3, H5 } from "components/Typography";
import { BlogData } from "modules/blogs/types";
import { makeStyles } from "@mui/styles";
import { convertToSlug } from "common";
import { useRouter } from "next/router";

const useStyles = makeStyles(() => ({
  // code section below is needed for line clamping properly
  titleClamp: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    overflow: "hidden",
  },
  lineClamp: {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 3,
    overflow: "hidden",
  },
}));

interface Props {
  blogData: BlogData;
  isMobile?: boolean;
}

export const BlogArticleCard: FC<Props> = ({ blogData, isMobile = false }) => {
  const classes = useStyles();
  const { push } = useRouter();

  const blogDetailsLink = useMemo(() => {
    const content_type = convertToSlug(blogData?.content_type);
    const title = convertToSlug(blogData?.title);

    return `/blogs/${content_type}/${title}/${blogData.uuid}`;
  }, [blogData?.content_type, blogData?.title, blogData.uuid]);

  const onNavigate = () => {
    push(blogDetailsLink);
  };

  return (
    <Paper
      sx={{
        padding: 3,
        textAlign: "left",
        bgcolor: isMobile ? "transparent" : "white",
        boxShadow: isMobile ? "none" : "",
        height: "100%",
        width: "100%",
      }}
    >
      <Box onClick={onNavigate}>
        <LazyImage
          width={300}
          height={240}
          src={blogData.thumbnail ?? ""}
          layout="responsive"
          sx={{
            transition: "transform 0.3s",
            "&:hover": { transform: "scale(1.1)", cursor: "pointer" },
          }}
        />
        <H5 color="#E94560" mt="1.5em">
          {blogData?.content_type ?? ""}
        </H5>
        <FlexBetween my={"1em"}>
          <H3 className={classes.titleClamp}>{blogData?.title ?? ""}</H3>
          <ArrowOutwardIcon />
        </FlexBetween>
        <Typography className={classes.lineClamp}>
          {blogData.brief_intro}
        </Typography>
        <FlexBox flexDirection={"column"} mt={"2em"}>
          <Typography sx={{ fontWeight: "bold" }}>
            {blogData.author ?? "Kachi"}
          </Typography>
          <Typography>{blogData?.created ?? ""}</Typography>
        </FlexBox>
      </Box>
    </Paper>
  );
};
